module.exports = __webpack_public_path__ + "static/media/trash-dontations.a36d28d9.svg";